// import styled from 'styled-components'
// import { Media, mbSize } from '../../theme'

// export const Wrapper = styled.div<{ $arrowPosition: number }>`
//   display: flex;
//   justify-content: center;
//   width: 100%;
//   overflow: hidden;

//   .swiper {
//     margin-left: unset;
//     width: 1040px;
//     overflow: unset;
//   }

//   .swiper-wrapper {
//     align-items: center;
//   }

//   .swiper-slide {
//     height: fit-content;
//   }

//   .swiper-button-prev {
//     left: ${({ $arrowPosition }) => `-${$arrowPosition}px`};
//     width: 80px;
//     &::after {
//       display: flex;
//       align-items: center;
//       justify-content: center;
//       border-radius: 50%;
//       width: 80px;
//       height: 80px;
//       color: #ffffff;
//       transition: all 0.3s;
//     }
//     &:hover {
//       &::after {
//         background: #f3512b66;
//       }
//     }
//   }

//   .swiper-button-next {
//     right: ${({ $arrowPosition }) => `-${$arrowPosition}px`};
//     width: 80px;
//     &::after {
//       display: flex;
//       align-items: center;
//       justify-content: center;
//       border-radius: 50%;
//       width: 80px;
//       height: 80px;
//       color: #ffffff;
//       transition: all 0.3s;
//     }
//     &:hover {
//       &::after {
//         background: #f3512b66;
//       }
//     }
//   }

//   .swiper-slide {
//     width: 195px !important;
//   }

//   .swiper-slide-active {
//     z-index: 5;
//     width: 340px !important;
//   }

//   ${Media.lessThan(Media.small)} {
//     width: ${mbSize(1678)} !important;
//     .swiper {
//       width: ${mbSize(1474)};
//       margin-left: ${mbSize(-204)};
//     }

//     .swiper-button-prev {
//       left: ${mbSize(24)};
//       width: ${mbSize(40)};
//       &::after {
//         width: ${mbSize(40)};
//         height: ${mbSize(80)};
//       }
//       &:hover {
//         &::after {
//           background: unset;
//         }
//       }
//     }

//     .swiper-button-next {
//       right: ${mbSize(24)};
//       width: ${mbSize(40)};
//       &::after {
//         width: ${mbSize(40)};
//         height: ${mbSize(80)};
//       }
//       &:hover {
//         &::after {
//           background: unset;
//         }
//       }
//     }

//     .swiper-slide {
//       width: ${mbSize(274)} !important;
//     }

//     .swiper-slide-active {
//       z-index: 5;
//       width: ${mbSize(478)} !important;
//     }
//   }
// `

import styled, { css } from 'styled-components'
import { mbSize, Media } from '../../theme'

export const Wrapper = styled.div<{ $arrowPosition: number }>`
  width: 100%;
  overflow: hidden;
  height: 580px;
  * {
    z-index: 0;
  }
  display: flex;
  justify-content: center;
  ${Media.lessThan(Media.small)} {
    height: ${mbSize(764)};
  }
`

export const SwiperWrapper = styled.div<{ $active: number; $slidesPerView: number }>`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  height: 100%;
  > * {
    flex-shrink: 0;
  }
  ${Media.lessThan(Media.small)} {
    width: ${mbSize(1474)};
    margin-left: ${mbSize(-204)};
  }
`

export const SwiperSlider = styled.div<{ $slidesPerView: number; $isCenter: boolean }>`
  position: relative;
  width: ${({ $isCenter }) => ($isCenter ? '350px' : '190px')};
  &:not(:last-child) {
    margin-right: 20px;
  }
  ${Media.lessThan(Media.small)} {
    width: ${({ $isCenter }) => ($isCenter ? mbSize(478) : mbSize(272))};
    &:not(:last-child) {
      margin-right: ${mbSize(26)};
    }
  }
`

const arrow = css`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  cursor: pointer;
  transition: background 300ms;
  z-index: 10;
  &:hover {
    background: #f3512b66;
  }
  ${Media.lessThan(Media.small)} {
    width: unset;
    height: unset;
    &:hover {
      background: unset;
    }
  }
`

export const PrevArrow = styled.div<{ $arrowPosition: number }>`
  ${arrow}
  left: ${({ $arrowPosition }) => `${-$arrowPosition}px`};
  top: 50%;
  transform: translateY(-50%);
  padding-right: 8px;
  ${Media.lessThan(Media.small)} {
    left: ${mbSize(24)};
  }
`

export const NextArrow = styled.div<{ $arrowPosition: number }>`
  ${arrow}
  right: ${({ $arrowPosition }) => `${-$arrowPosition}px`};
  top: 50%;
  transform: translateY(-50%);
  padding-left: 8px;
  ${Media.lessThan(Media.small)} {
    right: ${mbSize(24)};
  }
`
